import type { FragmentOf } from "@opensea/graphql"
import { FlexColumn, Separator, Table } from "@opensea/ui-kit"
import type { CollectionSweepQuoteReceiptFragment } from "./CollectionSweepQuoteReceipt.fragment"
import { CollectionSweepQuoteReceiptSummary } from "./CollectionSweepQuoteReceiptSummary"
import { CollectionSweepQuoteReceiptTotal } from "./CollectionSweepQuoteReceiptTotal"

type Props = {
  maxAmountOfItems: number
  quote: FragmentOf<typeof CollectionSweepQuoteReceiptFragment>
}

export const CollectionSweepQuoteReceipt = (props: Props) => {
  return (
    <FlexColumn className="w-full">
      <Table
        itemKey={(_, index) => index}
        items={[props]}
        renderRow={props => (
          <CollectionSweepQuoteReceiptSummary {...props.item} />
        )}
        size="xl"
      />
      <Separator className="mt-2" />
      <Table
        itemKey={(_, index) => index}
        items={[props]}
        renderRow={props => (
          <CollectionSweepQuoteReceiptTotal {...props.item} />
        )}
      />
    </FlexColumn>
  )
}
